import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import TreeSelect from "../../../component/TreeSelect/TreeSelect";
import DatePicker, {DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
const AddTest = () => {

console.log(new Date().getTime())
    const data = [
        {
            "label": "لوازم خانگی",
            "id" : 1,
            "children": [
                {
                    "label": "لوازم پخت و پز",
                    "id" : 2 ,
                    "children": [
                        {
                            "label": "سرخ کن",
                            "id" : 3
                        },
                        {
                            "label": "پلوپز",
                            "id" : 4
                        },
                        {
                            "label": "بخارپز",
                            "id" : 5
                        }
                    ]
                },
                {
                    "label": "نوشیدنی ساز",
                    "id" : 6,
                    "children": [
                        {
                            "label": "اسپرسوساز" ,
                            "id" : 7,
                        },
                        {
                            "label": "آب میوه گیری",
                            "id" : 8,
                        }
                    ]
                },
            ]
        },
        {
            "label": "مکمل بدنسازی",
            "id" : 9,
            "children": [
                {
                    "label": "گینر و افزایش وزن",
                    "id" : 10,

                    "children": [
                        {
                            "label": "یو اس ان" ,
                            "id" : 11,

                        },
                        {
                            "label": "ماسل تک" ,
                            "id" : 12,
                        },
                        {
                            "label": "اپلاید نوتریشن" ,
                            "id" : 13,
                        },
                        {
                            "label": "رول وان" ,
                            "id" : 14,
                        }
                    ]
                },
            ]
        },

    ]

    const defaultData = new DateObject({
        date: new Date(),
        calendar: persian
    })


    return (
        <div className="row">
            <div className="col-md-12">
                <TreeSelect label={"دسته بندی"} data={data} onChange={(value) => {
                    console.log(value)
                }}/>
            </div>

            <div className="col-md-4">
                <DatePicker
                    date = {defaultData}
                    format = "YYYY/MM/DD HH:mm:ss"
                    className="rmdp-mobile"
                    calendar={persian}
                    locale={persian_fa}
                    onChange={(date) => {
                        console.log(date);
                        date.hour = 0;
                        date.minute	 = 0;
                        date.second = 0;
                        console.log(data)
                    }}
                />
            </div>
        </div>

    );
}

export default AddTest;